import React from 'react';
import parse from 'html-react-parser';
//conponents
import Accordion from 'react-bootstrap/Accordion';
import Image from '../image/Image';
//content
import { footerData } from '../../content/footer';
import { trademark } from '../../documents/disclosures/generic';
// scripts
import { placeholderDarker } from '../../scripts/media';
import { appStoreAppLink, googlePlayAppLink } from '../../scripts/data';
//styles
import './footer.scss';
//interfaces
import { IColLInk } from '../../interfaces/footer';
// Images
import appStore from '../../graphics/graphic-icon-app-store.webp';
import playStore from '../../graphics/graphic-icon-play-store.webp';
import privacyImg from '../../graphics/graphic-data-privacy.svg';
import diversityImg from '../../graphics/graphic-exp-dei.svg';

type FooterProps = {
  homepage?: boolean;
  tradeMarkFootNote?: string;
};

class Footer extends React.Component<FooterProps> {
  constructor(props: FooterProps) {
    super(props);
  }
  render() {
    const id = 'footer';
    const footerDataUpdated = () => {
      let newFooterdata = [];
      if (this.props.homepage) {
        for (const col of footerData.mainCols) {
          let n: any = col;
          n.links = col.links.filter((el: IColLInk) => {
            return (el.hasOwnProperty('homepage') && el.homepage) || !el.hasOwnProperty('homepage');
          });
          newFooterdata.push(n);
        }
      } else {
        let a = footerData.mainCols.slice(0, -1); //remove the last element
        for (const col of a) {
          let n: any = col;
          n.links = col.links.filter((el: IColLInk) => {
            return (
              (el.hasOwnProperty('homepage') && !el.homepage) || !el.hasOwnProperty('homepage')
            );
          });
          newFooterdata.push(n);
        }
      }
      return newFooterdata;
    };
    const returnFootNote = () => {
      return this.props.tradeMarkFootNote ? parse(this.props.tradeMarkFootNote) : '';
    };
    return (
      <footer
        id={id}
        className="bg-light pt-6 pt-md-7 pt-lg-8">
        <div className="container ">
          <Accordion
            alwaysOpen
            flush
            className="d-lg-flex links-unstyled justify-content-lg-between accordion-lg-none accordion-plus-icon">
            {footerDataUpdated().map((col, index: number) => (
              <Accordion.Item
                eventKey={`${index}${id}`}
                key={index}>
                <p className="d-none d-lg-block h7 text-secondary">{col.column}</p>
                <Accordion.Button
                  className="d-lg-none mb-0 h7"
                  id={`${index}${id}h`}
                  aria-controls={`${index}${id}`}>
                  {col.column}
                </Accordion.Button>
                <Accordion.Body
                  as="ul"
                  aria-describedby={`${index}${id}h`}
                  id={`${index}${id}`}
                  className="list-unstyled">
                  {col.links.map((link: IColLInk, i: number) => (
                    <li key={`${i}${index}`}>
                      <a
                        href={link.link}
                        {...link?.attributes}>
                        {parse(link.title)}
                      </a>
                    </li>
                  ))}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          <div className="d-lg-flex text-center text-lg-start mt-lg-5 py-6 justify-content-lg-between mid-wrapper">
            <div className="d-flex flex-wrap flex-xl-nowrap">
              <div className="d-lg-flex mb-4 mb-xl-0 pe-xl-7 w-100 w-xl-auto">
                <Image
                  src={diversityImg}
                  className="me-lg-2 mb-2 mb-lg-0"
                  width="32"
                  height="32"
                  alt="Experian's Diversity logo."
                  lazyLoading
                  placeholder={placeholderDarker}
                />
                <div>
                  <div className="eyebrow-text">Experian's Diversity, Equity and Inclusion</div>
                  <a
                    href="/diversity/"
                    data-link-both="dei|footer-banner">
                    Learn more how Experian is committed
                  </a>
                </div>
              </div>
              <div className="d-lg-flex px-xl-0 w-100 w-xl-auto">
                <Image
                  src={privacyImg}
                  className="me-lg-2 mb-2 mb-lg-0"
                  width="35"
                  height="20"
                  alt="Data privacy logo."
                  lazyLoading
                  placeholder={placeholderDarker}
                />
                <div>
                  <div className="eyebrow-text">Data privacy</div>
                  <a
                    href="https://consumerprivacy.experian.com"
                    target="_blank"
                    rel="noopener">
                    Your privacy choices
                  </a>
                </div>
              </div>
            </div>
            <div className="d-xl-flex d-lg-table flex-wrap flex-xl-nowrap">
              <div className="app-badge d-flex justify-content-center  me-xl-1 mt-4 mt-lg-0">
                <a
                  href={appStoreAppLink}
                  target="_blank"
                  rel="noopener"
                  className="d-block pe-2"
                  data-op="FRCR-XXX-XXX">
                  <Image
                    width="120"
                    lazyLoading
                    height="36"
                    src={appStore}
                    alt="Download on the Apple App Store."
                    placeholder={placeholderDarker}
                  />
                </a>
                <a
                  href={googlePlayAppLink}
                  target="_blank"
                  rel="noopener"
                  data-op="FRCR-XXX-XXX"
                  className="d-block">
                  <Image
                    width="120"
                    height="36"
                    lazyLoading
                    src={playStore}
                    alt="Get it on Google Play."
                    placeholder={placeholderDarker}
                  />
                </a>
              </div>
              <ul className="mt-4 mt-xl-0 d-flex list-unstyled mb-0 justify-content-center">
                {footerData.social.map((item, index) => (
                  <li
                    key={index}
                    className="mb-0">
                    <a
                      className="btn h3 mb-0 px-1 py-0 lh-1"
                      aria-label={item.label}
                      href={item.link}
                      target="_blank"
                      rel="noopener">
                      <span
                        className={item.icon}
                        aria-hidden="true"></span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="bottom-wrapper links-unstyled">
            <ul className="list-unstyled text-center d-lg-flex justify-content-lg-between">
              {footerData.legal.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.link}
                    {...(item.target && { target: item.target })}
                    {...(item.rel && { rel: item.rel })}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="pb-5 pt-3 pb-md-7 pt-md-4">
            <p>{parse(`© ${new Date().getFullYear()} Experian. All rights reserved.`)}</p>
            <p>
              {returnFootNote()}
              {parse(trademark)}
            </p>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
